/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-interaction-state-base: var(--background, var(--nve-sys-layer-canvas-background));
  --color: var(--nve-sys-text-muted-color);
  --border-radius: var(--nve-ref-border-radius-full);
  --line-height: 0;
  --padding: 0;
  --height: var(--nve-ref-size-800);
  --min-width: var(--nve-ref-size-800);
  --font-size: calc(var(--width) / 2.3);
  --_icon-color: var(--color);
}

/* disable pseudo element on base button */
[internal-host]::after {
  display: none !important;
}

:host([size='sm']) {
  --height: var(--nve-ref-size-700);
  --min-width: var(--nve-ref-size-700);
}

:host([size='lg']) {
  --min-width: var(--nve-ref-size-1000);
  --height: var(--nve-ref-size-1000);
  --padding: 0;
}

:host([container='flat'][selected]) [interaction-state],
:host([container='flat']:state(selected)) [interaction-state],
:host([container='flat'][pressed]) [interaction-state],
:host([container='flat']:state(pressed)) [interaction-state] {
  --nve-sys-interaction-state-ratio: var(--nve-sys-interaction-state-ratio-selected);
}

:host([container*='flat']) {
  --background: transparent;
  --border-radius: var(--nve-ref-border-radius-xs);
}

:host([container*='flat']:state(disabled)) {
  --color: var(--nve-sys-interaction-disabled-color);
  --background: transparent;
}

:host([container*='flat']:state(disabled)) [interaction-state] {
  --nve-sys-interaction-state-ratio: 0;
}

:host([container*='flat']:state(selected)) {
  --color: var(--nve-sys-interaction-selected-color);
}

nve-icon {
  --color: var(--_icon-color);
  pointer-events: none;
}
